import { Row, Col } from 'react-bootstrap';
import UserAddGeneral from '../../UserAddGeneral';
import UserAddAbout from '../../UserAddAbout';
import UserAddResidence from '../../UserAddResidence';

const OnboardingStepAbout = ({
    formData,
    handleChange,
    handleDeleteImage,
    profileImage,
    errors,
    companies = [],
    createdDate,
}) => {
    return (
        <>
            <Row>
                <Col>
                    <UserAddGeneral
                        formData={formData}
                        profileImage={formData.profileImagePreview || profileImage}
                        handleChange={handleChange}
                        handleDeleteImage={handleDeleteImage}
                        errors={errors}
                        companies={companies}
                        isEditPage={false}
                        hideEdit={true}
                    />
                </Col>
            </Row>

            <Row className="my-5">
                <Col><h2>About</h2></Col>
            </Row>

            <Row>
                <Col>
                    <UserAddAbout
                        formData={formData}
                        handleChange={handleChange}
                        errors={errors}
                        companies={companies}
                        createdDate={createdDate}
                        disableEmail={true}
                        hideCompanyFields={true}
                        isEditPage={false}
                        hideEdit={true}
                    />
                </Col>

                <Col>
                    <UserAddResidence
                        formData={formData}
                        handleChange={handleChange}
                        errors={errors}
                        isEditPage={false}
                        hideEdit={true}
                        clearCityOnCountryChange={true}
                        resolveCountryValue={true}
                        zipOptional={true}
                    />
                </Col>
            </Row>
        </>
    );
};

export default OnboardingStepAbout;
